import React from 'react';
import DeviceManagement from './DeviceManagement';
import { useTranslation } from 'react-i18next';
import { PAGE_TITLE_ID } from 'reusable/TableScroll';

const Device: React.FC = () => {
  const { t } = useTranslation('device');
  return (
    <section className="px-4 py-3 space-y-5">
      <h6 id={PAGE_TITLE_ID} className="font-bold text-title">{t('title')}</h6>
      <div className="bg-white rounded-md p-4">
        <DeviceManagement />
      </div>
    </section>
  );
};
export default Device;
